/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelect/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelect({
  children,
  keepValueUnchanged,
  viewPath = "/DesignSystem/TysiaSelect",
  alignSelf = "flex-start",
  alignItems,
  flexDirection = "column",
  flexGrow = 1,
  flexShrink = 1,
  flexBasis,
  marginTop = 24,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  maxWidth,
  height,
  onMouseEnter,
  onMouseLeave,
  disabled,
  required,
  id,
  allowEmptyChoice = true,
  from,
  size,
  dock,
  field = "text",
  focused,
  hovered,
  invalid,
  valid,
  value,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  placeholder
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaSelect.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--as-1-KCfUT': alignSelf,'--ai-2-KCfUT': alignItems,'--fd-3-KCfUT': flexDirection,'--fg-4-KCfUT': flexGrow,'--fs-5-KCfUT': flexShrink,'--fb-6-KCfUT': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--mt-7-KCfUT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-8-KCfUT': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-9-KCfUT': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-10-KCfUT': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mw-11-KCfUT': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--h-12-KCfUT': typeof height === 'number' ? `${height}px` : height,'--c-13-KCfUT': disabled ? "default" : "pointer"}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 required={required}
 id={id}
 allowEmptyChoice={allowEmptyChoice}
 from={from}
 size={size}
 dock={dock}
 field={field}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 value={value}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 keepValueUnchanged={keepValueUnchanged}
 placeholder={placeholder}
>
{children}
</Children>
</div>
</React.Fragment>)
}